import { render, staticRenderFns } from "./RectangularStencil.vue?vue&type=template&id=47956612"
import script from "./RectangularStencil.vue?vue&type=script&lang=js"
export * from "./RectangularStencil.vue?vue&type=script&lang=js"
import style0 from "./RectangularStencil.vue?vue&type=style&index=0&id=47956612&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports